import Vue from 'vue';


// https://vuejs.org/v2/guide/mixins.html#Custom-Option-Merge-Strategies
// https://github.com/vuejs/vue/blob/7912f75c5eb09e0aef3e4bfd8a3bb78cad7540d7/src/core/util/options.js#L259
Vue.config.optionMergeStrategies.constants = Vue.config.optionMergeStrategies.provide;

// Inspired by https://github.com/kay999/vue-constants/blob/48a5c7b757ce7f7cc17457195cea4e25640b793b/src/index.js
Vue.mixin({
    beforeCreate() {
        const def = this.$options.constants;
        if (!def) return;

        const constants = (typeof def === 'function') ? def.bind(this)() : def;

        //+ Vue 2.7 rewrote the `provide` merge strategy (which we piggyback
        //+ on above) to return a null-prototype object via `Object.create(null)`,
        //+ so `constants.hasOwnProperty` is undefined when multiple mixins
        //+ contribute `constants`. Call via `Object.prototype` to be safe.
        const hasOwn = Object.prototype.hasOwnProperty;

        for (const key in constants) {
            if (hasOwn.call(constants, key)) {
                this[key] = constants[key];
            }
        }
    },
});
